import { asyncAction } from 'lib/action';

export const getNotificationsAction = asyncAction('NOTIFICATIONS/GET_NOTIFICATIONS');
export const updateNotificationsAction = asyncAction('NOTIFICATIONS/UPDATE_NOTIFICATIONS');
